module.exports = __webpack_public_path__ + "d4f0abb561dd952730cd06be8987766f.pdf";